import { withBreakpoints } from 'react-breakpoints'

import { Step } from '../../components/Step'
import { Info } from '../../components/Info'
import { TabsInfo } from '../../../components/Tabs'

const InitialDescription = ({
  currentStep,
  breakpoints,
  currentBreakpoint,
  description,
  rules,
  title
}) => {
  const isMobile = breakpoints[currentBreakpoint] < breakpoints.tablet

  return (
    <Step step={1} currentStep={currentStep}>
      {(isMobile && <TabsInfo description={description} rules={rules} />) || (
        <Info title={title} description={description} rules={rules} />
      )}
    </Step>
  )
}

export default withBreakpoints(InitialDescription)
